<template>
  <div>
    <Header />
    <div id="content_area2" class="content-web container mt-5">
      <div style="clear: both;"></div>

      <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
          <div class="col-12">
            <label class="title">BỘ LỌC:</label>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
            <input
              v-model="title"
              placeholder="Tiêu đề"
              class="form-control mr-2 mb-2"
              id="title"
              v-on:keyup.enter="search()"
            />
            <v-select
              class="v-select-option mr-2 mb-2"
              label="name"
              :options="dataTypes"
              v-model="ipType"
              placeholder="Lĩnh vực: Tất cả"
            ></v-select>
            <button
              id="btnSearch"
              class="btn btn_control mr-2"
              @keyup.enter="search()"
              v-on:click="search()"
            >Tìm kiếm</button>
            <button
              type="submit"
              class="btn btn_control mr-1 mb-2"
              v-on:click="clearFilterSearch()"
            >Xóa</button>
          </div>
        </div>
      </div>

      <div class="table-box list-grid mb-5" v-if="loading">
        <div class="text-center">
          <div class="spinner-border text-dark" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <div v-else class="table-box list-grid mb-5">
        <div class="title">
          <h6>Sáng kiến của tôi</h6>
        </div>
        <div class="content-table">
          <table class="table table-responsive">
            <thead>
              <tr>
                <th style="width: 5%;">ID</th>
                <th style="width: 20%;">Tên sáng kiến</th>
                <th style="width: 25%;">Giới thiệu</th>
                <th style="width: 15%;">Lĩnh vực</th>
                <th style="width: 10%;">Ngày tạo</th>
                <th style="width: 10%;">Thưởng sáng kiến</th>
                <th style="width: 10%;">Trạng thái</th>
                <th style="width: 10%;">Ghi chú</th>
                <th style="width: 10%;">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ipc) in listIp" :key="ipc.id">
                <td>{{ipc.id}}</td>
                <td>
                  <a
                    :href="`${ipDetailUrl}/${ipc.id}`"
                    @click="redirect(`${ipDetailUrl}/${ipc.id}`)"
                  >{{ipc.title}}</a>
                </td>
                <td>{{ipc.summary}}</td>
                <td>{{getTypeName(ipc.ideaType)}}</td>
                <td>{{ipc.createdTime | date}}</td>
                <td>{{ipc.bonusMoney}}</td>
                <td>{{getStatusName(ipc.status)}}</td>
                <td>{{ipc.updatedReason}}</td>
                <td>
                  <div class="dropdown">
                    <button
                      class="dropbtn dropdown-toggle"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Hành động
                      <span class="caret"></span>
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                      v-if="ipc.status == 'submit' || ipc.status == 'draft' || ipc.status =='request_update'"
                    >
                      <!-- <a
                        class="dropdown-item"
                        v-if="ipc.status == 26 && isUpdateVersion[ipc.id]"
                        href="javascript:void(0)"
                        @click="redirect(`${ipUpdateVersion}/${ipc.id}`)"
                      >Upgrade Version</a>-->
                      <a
                        class="dropdown-item"
                        href="javascript:void(0)"
                        @click="redirect(`${ipEditUrl}/${ipc.id}`)"
                        v-if="ipc.status == 'submit' || ipc.status == 'draft' || ipc.status =='request_update'"
                      >Sửa</a>
                    </div>
                    <div v-else class="dropdown-menu dropdown-hide"></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-4 pagination" v-if="total > pageSize">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
            <span
              v-if="((pageSize*pageIndex)>total)"
            >{{pageSize*(pageIndex-1)+1}}-{{total}} of {{total}}</span>
            <span
              v-if="((pageSize*pageIndex)<=total)"
            >{{pageSize*(pageIndex-1)+1}}-{{pageSize*pageIndex}} of {{total}}</span>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex">
            <b-pagination v-model="pageIndex" :total-rows="total" :per-page="pageSize"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import helper from "../../common/helper";
import moment from "moment";
import { BPagination } from "bootstrap-vue";
import MasterDataCommon from "../../common/masterData";
import IdeaCommon from "../../common/idea";
import CompanyCommon from "../../common/company";
import * as CONFIG from "../../config/index";
export const MASTER_DATA_API_URL = `${CONFIG.API_URL}/master-data`;
import axios from "axios";
import { checkIsUpdateVersion } from "../../common/updateVersion";

import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";

export default {
  name: "my_submission",
  components: {
    Header,
    Footer,
    "b-pagination": BPagination
  },
  data() {
    return {
      listIp: [],
      title: "",
      ipType: [],
      Status: [],
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      ipDetailUrl: `${CONFIG.CLIENT_URL}/#/ip-view`,
      ipEditUrl: `${CONFIG.CLIENT_URL}/#/edit-submission`,
      ipUpdateVersion: `${CONFIG.CLIENT_URL}/#/update-version`,
      loading: false,
      isUpdateVersion: {},
      dataTypes: [],
      listStatus: []
    };
  },
  methods: {
    async fetchData() {
      Promise.all([
        MasterDataCommon.sync.getByType("idea_status"),
        MasterDataCommon.sync.getByType("idea_type")
      ]).then(res => {
        this.listStatus = res[0];
        this.dataTypes = res[1];
      });
    },
    redirect: function(href) {
      window.location.href = href;
    },
    date: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    search() {
      this.loading = true;
      const username = this.$cookies.get("username") || "";
      const title = this.title ? this.title : "";
      const type = this.ipType ? this.ipType.code : "";
      axios
        .post(
          `${CONFIG.API_URL}/idea/my-submission?pageNo=${this.pageIndex}&pageSize=${this.pageSize}`,
          {
            account: username,
            companyCode: "",
            title: title,
            type: type
          }
        )
        .then(async response => {
          this.listIp = response.data.data.items;
          this.total = response.data.data.totals;
          this.loading = false;
          //   await this.checkUpdateVersion();
        })
        .catch(error => {
          this.listIp = [];
          this.total = 0;
          this.loading = false;
        });
    },
    exportMySubmissionExcel: function() {
      this.loading = true;
      var title = $("#title").val() != undefined ? $("#title").val() : "";
      this.axios
        .post(
          `${CONFIG.API_URL}/ip/exportMySubmission?title=` +
            this.title +
            `&ipType=` +
            this.ipType +
            `&status=` +
            this.Status,
          {
            responseType: "blob"
          }
        )
        .then(response => {
          const headers = response.headers;
          const blob = new Blob([response.data], {
            type: headers["content-type"]
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "ExcelMySubmission.xls";
          link.click();
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    clearFilterSearch() {
      this.title = "";
      this.ipType = "";
      this.search();
    },
    getStatusName(statusCode) {
      if (!statusCode) {
        return "";
      }
      const typeCode = this.listStatus.find(p => p.code === statusCode);
      if (typeCode) {
        return typeCode.name;
      }
      return "";
    },
    getTypeName(code) {
      if (!code) {
        return "";
      }
      const typeData = this.dataTypes.find(p => p.code === code);
      if (typeData) {
        return typeData.name;
      }
      return "";
    }
  },
  watch: {
    pageIndex: {
      immediate: true,
      handler(newVal, oldVal) {
        this.search();
      }
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    date: function(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.search();
  }
};
</script>

<style scoped>
@import "../../assets/css/filter_customs.css";
@import "../../assets/css/table_customs.css";
</style>

<style>
.v-select-option .vs__dropdown-toggle {
  min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/MySubmission.vue